/*
  AnimatedNumber — spring-animated number that morphs in/out when the
  value changes. Used across the round screen for hero yardages so the
  number "lands" instead of jump-cutting.
*/
import { motion, AnimatePresence } from "framer-motion";

export default function AnimatedNumber({ value, className, testid }) {
  return (
    <span className={className} data-testid={testid}>
      <AnimatePresence mode="popLayout" initial={false}>
        <motion.span
          key={String(value)}
          initial={{ y: 14, opacity: 0, scale: 0.9 }}
          animate={{ y: 0, opacity: 1, scale: 1 }}
          exit={{ y: -14, opacity: 0, scale: 0.9 }}
          transition={{ type: "spring", stiffness: 380, damping: 28 }}
          className="inline-block"
        >
          {value}
        </motion.span>
      </AnimatePresence>
    </span>
  );
}
